<template>
    <div>
        <myHeader></myHeader>
        <div class="banner_wrap">
            <div class="banner">
                <el-carousel :interval="5000" arrow="hover" trigger="click" ref="carousel" @change="carouselChange">
                    <el-carousel-item v-for="(item,index) in slideList" :key="index">
                        <div class="banner_text">
                            <b></b>
                            {{siteInfo.company_english_name}}<br/>
                            {{siteInfo.name}}
                        </div>
                        <img :src="item.image" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="quote_wrap">
            <div class="quote">
                <strong>寻找适合您的货运报价</strong>
                <div class="quote_title"><i></i>获取专家报价<i></i></div>
                <div class="quote_nr">
                    我们的专家将根据您的货物特点和市场洞察，为您的下一批货物提供定制报价，我们全方位的货运服务组合供您选择，您不需要局限于单一运输模式！
                </div>
                <button type="button" @click="centerDialogVisible = true">获取报价</button>
            </div>
        </div>
        <div class="about_wrap">
            <div class="about_nr">
                <div class="about_title">关于万事航</div>
                <div class="about_text">
                    <div class="about_img">
                        <img src="../../static/images/about02.png" alt="">
                    </div>
                    <div class="about_p">
                        <p>万事航国际物流集团由深圳市万事航国际货运代理有限公司、美国Mascot International Logistics,
                            Inc和加拿大Mascot International Logistics (Canada), Inc. 组成，是一家专业从事中、美、
                            加国际物流的跨国企业。</p><br/>
                        <p>深圳市万事航国际货运代理有限公司成立于2011年，美国公司成立于2014年，加拿大公司成立于2023年，公司
                            谨奉以客户为本的服务理念，提供定制化服务，让客户的国际物流变的简单。</p>
                    </div>
                    <button type="button" @click="to_about()">了解更多</button>
                </div>
            </div>
            <div class="about_bottom">
                <div class="about_news">
                    <div class="about_news_ul">
                        <div class="about_news_title">
                            <b>行业动态</b>
                        </div>
                        <div class="about_news_ulst">
                            <div class="about_news_li" v-for="(item,index) in newsList" :key="index" @click="to_details(item.id,item.links)">
                                <b>{{item.money_day}}</b>
                                <span>{{item.title}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="about_news_ul">
                        <div class="about_news_title">
                            <b>万事航信息</b>
                        </div>
                        <div class="about_news_ulst">
                            <div class="about_news_li" v-for="(item,index) in wshNewsList" :key="index" @click="to_details(item.id,item.links)">
                                <b>{{item.money_day}}</b>
                                <span>{{item.title}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="about_news_ul">
                        <div class="about_news_title">
                            <b>货物追踪</b>
                        </div>
                        <div class="about_news_ulst">
                            <div class="about_news_li">
                                <span @click="to_track()">Track and Trace</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="service_wrap">
            <div class="service_top">
                <div class="service_introd">
                    <b>业务范围</b>
<!--                    <p>我是一段或长或短的业务范围价绍，我是一段或长或短的业务范围价绍我是一段或长或短的业务范围价绍，我是一段或长或短的业务范围价绍!</p>-->
                </div>
                <div class="service_one_wrap">
                    <div class="service_one" :style="{'background-image':'url('+ serviceOne.bg_image +')'}">
                        <b>01</b>
                        <strong>{{serviceOne.title}}</strong>
                        <p>{{serviceOne.summary}}</p>
                        <span @click="to_service(serviceOne.id)">了解更多</span>
                    </div>
                </div>
            </div>
            <div class="service_ul">
                <div class="service_li" v-for="(item,index) in serviceList" :key="index" :style="{'background-image':'url('+ item.bg_image +')'}">
                    <b>0{{item.id}}</b>
                    <strong>{{item.title}}</strong>
                    <p>{{item.summary}}</p>
                    <span @click="to_service(item.id)">了解更多</span>
                </div>
            </div>
        </div>
        <div class="project_wrap">
            <div class="project">
                <div class="project_title">产品方案</div>
                <div class="project_nr">
                    <div class="project_mid_img">
                        <b @click="to_case(9)">{{max_huoName}}</b>
                        <strong @click="to_case(10)">{{pu_huoName}}</strong>
                    </div>
                    <div class="project_ul_left">
                        <div class="project_li" v-for="(item,index) in solutionList" :key="index" v-show="item.type === 0 && item.id!==9" @click="to_case(item.id)">
                            <div class="project_li_title">
                                <b>{{item.title}}</b>
                                <i></i>
                            </div>
                            <p>{{item.summary}}</p>
                        </div>
                    </div>
                    <div class="project_ul_right">
                        <div class="project_li" v-for="(item,index) in solutionList" :key="index" v-show="item.type === 1 && item.id!==10" @click="to_case(item.id)">
                            <div class="project_li_title">
                                <i></i>
                                <b>{{item.title}}</b>
                            </div>
                            <p>{{item.summary}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shixiao">
            <img src="../../static/images/shixiao.jpg" alt="">
        </div>
        <div class="parents_wrap">
            <div class="parents">
                <div class="parents_title">合作伙伴</div>
                <div class="parents_ul">
                    <div class="parents_li" v-for="(item,index) in partnerList" :key="index" @click="to_parents(item.url)">
                        <img :src="item.logo" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="family_wrap">
            <div class="family">
                <div class="family_li" v-for="url in url_img" :key="url">
                    <el-image :src="url" :preview-src-list="url_img" fit="fill"></el-image>
                </div>
                <div class="family_title" @click="to_team()">
                    <b>万事航大家庭</b>
                    <span>致力于建立快乐的服务团队，并将我们的价值传递给我们的客户！</span>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
        <el-dialog title="帮助您解决棘手的挑战" :visible.sync="centerDialogVisible" center class="consult">
            <div class="consult_tips">更好的管理您的货运和物流费用，避免因不断变化的货运市场和全球供应链的复杂性而带来的意外成本！</div>
            <div class="consult_form">
                <div class="form_input">
                    <el-input v-model="ming" placeholder="名*" class="input_li"></el-input>
                    <el-input v-model="xing" placeholder="姓*" class="input_li"></el-input>
                    <el-input v-model="email" placeholder="电子邮箱*" class="input_li"></el-input>
                    <el-input v-model="phone" placeholder="电话*" class="input_li"></el-input>
                    <el-input v-model="company" placeholder="公司*" class="input_li"></el-input>
                    <el-input v-model="state" placeholder="国家/地区*" class="input_li"></el-input>
                    <el-input type="textarea" :rows="3" v-model="contact_text" placeholder="详细信息" class="input_li"></el-input>
                </div>
                <div class="form_input_check">
                    <el-checkbox v-model="checked"></el-checkbox>
                    我同意万事航向我提供个性化的信息和其他营销内容，以支持我的业务需求，您可以随时通过每封电子邮件中的偏好管理链接，取消订阅营销电子邮件!
                </div>
                <button type="button" @click="submit()">与专家联系</button>
            </div>
        </el-dialog>

        <el-dialog title="提交成功"
                   :visible.sync="tijiao_flag" class="tijiao">
            <div class="tijiao_form">
                <div class="tijiao_tips">
                    您已成功提交信息，稍后将会有专家与您联系。
                </div>
                <div class="tijiao_btn">
                    <button type="button" @click="tips_close()">我知道了</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :title="news_details.title" :visible.sync="details_flag" class="news_details" top="70px">
            <div class="details_nr" v-if="news_details.content" v-html="news_details.content"></div>
            <el-empty :image-size="160" class="details_empty" v-else></el-empty>
        </el-dialog>
    </div>
</template>

<script>
import myHeader from '../components/headerIndex.vue'
import MyFooter from '../components/footer.vue'
import {throttle} from '../axios/util'
export default {
    name: 'index',
    components: {MyFooter, myHeader},
    data () {
        return {
            video_mp4:'../../static/images/mascot.mp4',
            slideList:[],
            siteInfo:{},
            serviceOne:{},
            serviceList:[],
            solutionList:[],
            newsList:[],
            wshNewsList:[],
            partnerList:[],
            max_huoName:'',
            pu_huoName:'',
            centerDialogVisible: false,
            ming:'',
            xing:'',
            email:'',
            phone:'',
            company:'',
            state:'',
            contact_text:'',
            position:'',
            department:'',
            states: '',
            checked:false,
            tijiao_flag:false,
            details_flag:false,
            news_details:{},
            url_img: []

        }
    },
    created () {
        this.pageSiteMsg();
        this.pageIndex();
        this.pageSecondHome();
        this.pageNewsList();
        this.pageTeam();
    },
    computed: {
        phoneRegex() {
            return /^1[3456789]\d{9}$/;
        },
        emailRegex() {
            return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
        },
    },
    methods: {
        pageSiteMsg () {
            this.$api.siteMsg().then(res => {
                this.siteInfo = res.data.siteMsg;
            });
        },
        pageIndex () {
            this.$api.index().then(res => {
                this.slideList = res.data.slideList;
                let service = res.data.businessList;
                this.serviceOne = service.shift();
                this.serviceList = service;
            });
        },
        pageSecondHome () {
            this.$api.secondHome().then(res => {
                this.solutionList = res.data.solutionList;
                this.partnerList = res.data.partnerList;
                let max_name = this.solutionList.find((item) => {
                    return item.id === 9
                })
                this.max_huoName = max_name.title;
                let pu_name = this.solutionList.find((item) => {
                    return item.id === 10
                })
                this.pu_huoName = pu_name.title;
            });
        },
        pageTeam() {
            this.$api.teamImageList().then(res => {
                let urlList = res.data;
                this.url_img = urlList.map((item) => {
                    return item.image
                })
            });
        },
        pageNewsList(){
            let params = {
                page:1,
                pageSize:4,
                newsType:0
            };
            this.$api.newsList(params).then(res => {
                this.newsList = res.data.itemList;
            });
            let params2 = {
                page:1,
                pageSize:4,
                newsType:1
            };
            this.$api.newsList(params2).then(res => {
                this.wshNewsList = res.data.itemList;
            });
        },
        to_details(id,links){
            console.log(links);
            if(links){
                window.open(links, '_blank')
            }else{
                this.details_flag = true;
                let params = {
                    id:id
                };
                this.$api.newsDetail(params).then(res => {
                    this.news_details = res.data;
                });
            }
        },
        to_parents(links){
            window.open(links, '_blank')
        },
        to_service(id){
            this.$router.push({
                path:'/service',
                query: {
                    id:id
                }
            });
        },
        to_about(){
            this.$router.push({
                path:'/about'
            });
        },
        to_team(){
            this.$router.push({
                path:'/about_team'
            });
        },
        to_case(id){
            this.$router.push({
                path:'/product_case',
                query: {
                    id:id
                }
            });
        },
        to_track(){
            window.open('https://www.track-trace.com/', '_blank')
        },
        submit: throttle(function () {
            if (this.ming==='') {
                this.$message.warning('请输入名字');
                return false;
            }
            if (this.xing==='') {
                this.$message.warning('请输入姓氏');
                return false;
            }
            if (!this.emailRegex.test(this.email)) {
                this.$message.warning('请输入正确的邮箱');
                return false;
            }
            if (!this.phoneRegex.test(this.phone)) {
                this.$message.warning('请输入正确手机号码');
                return false;
            }
            if (this.company==='') {
                this.$message.warning('请输入公司名称');
                return false;
            }
            if (this.state==='') {
                this.$message.warning('请输入国家/地区');
                return false;
            }
            if (!this.checked) {
                this.$message.warning('请勾选同意万事航向您提供个性化的信息和其他营销内容！');
                return false;
            }
            let params = {
                lastName:this.ming,
                firstName:this.xing,
                email: this.email,
                mobile: this.phone,
                companyName: this.company,
                country: this.state,
                remark:this.contact_text
            };
            this.$api.submitQuotation(params).then(res => {
                if(res.code===1){
                    setTimeout(()=>{
                        this.ming = '';
                        this.xing = ''
                        this.email=''
                        this.phone=''
                        this.company=''
                        this.state=''
                        this.contact_text=''
                        this.centerDialogVisible = false
                        this.tijiao_flag = true
                    }, 500);
                }else{
                    this.$message.warning('提交失败，请重新提交！')
                }
            });
        }, 1000),
        tips_close(){
            this.tijiao_flag = false;
        },
        carouselChange(index) {
            const videos = this.$refs.videos;
            videos.forEach((video) => {
                video.currentTime = 0; // 将视频回到起始时间
                video.pause(); // 暂停视频播放
            });
            videos[index].play();
        },
        playNextVideo(index) {
            const videos = this.$refs.videos;
            let nextIndex = index;
            if (index < this.vidData.length - 1) {
                nextIndex = nextIndex + 1;
            } else {
                nextIndex = 0;
            }
            const carousel = this.$refs.carousel;
            carousel.setActiveItem(nextIndex);
            const nextVideo = videos[nextIndex];
            videos.forEach((video) => {
                video.pause();
                video.currentTime = 0;
            });
            setTimeout(() => {
                nextVideo.play();
            }, 1000);
        },



    }


}
</script>

<style scoped>
.tsgz-video{width:100%;height:auto;display:block;}
.news_details{width:100%;}
/deep/ .news_details .el-dialog{width:1200px;height:800px;margin-top:70px;}
/deep/ .news_details .el-dialog__header{text-align:center;}
/deep/ .news_details .el-dialog__title{font-weight:bold;}
/deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:20px 50px 30px;}
.details_nr{width:100%;height:700px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
.details_nr img{max-width:100%;height:auto;display:block;}
.details_nr::-webkit-scrollbar {width:0;height:0;}
.details_nr::-webkit-scrollbar-thumb {background: transparent;}
.details_nr::-webkit-scrollbar-track {background: transparent;}
.details_empty{margin-top:100px;}
.tijiao{width:100%;}
/deep/ .tijiao .el-dialog{width:400px;}
/deep/ .tijiao .el-dialog__header{text-align:center;}
/deep/ .tijiao .el-dialog__title{font-weight:bold;}
/deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:20px 20px 30px;}
.tijiao_form{width:100%;min-height:100px;height:auto;}
.tijiao_tips{width:100%;height:auto;font-size:14px;color:#333;line-height:24px;display:block;text-align:center;}
.tijiao_btn{margin-top:30px;padding:0;}
.tijiao_btn button{width:100%;height:44px;background:#0c57c3;font-size:16px;color:#fff;line-height:44px;
    text-align:center;display:block;cursor:pointer;transform:0.8s;}
.tijiao_btn button:hover{background: #1b5fc3;transform:0.8s;}
.consult{width:100%;}
/deep/ .consult .el-dialog{width:1000px;}
/deep/ .consult .el-dialog__title{font-weight:bold;font-size:24px;line-height:50px;color:#000;}
/deep/ .consult .el-dialog__header{padding-bottom:0;}
.consult_tips{width:100%;height:30px;font-size:14px;color:#333;line-height:30px;display:block;text-align:center;}
/deep/ .consult .el-dialog--center .el-dialog__body{padding:0 50px 30px;}
.consult_form{width:100%;height:370px;padding:20px 40px 0;}
.form_input{width:100%;height:210px;}
.form_input .input_li{width:260px;height:auto;float:left;margin-left:20px;margin-top:15px;}
.form_input .input_li:nth-child(3n-2){margin-left:0;}
.form_input .input_li:nth-child(7){width:100%;}
/deep/ .form_input .input_li:nth-child(7) .el-textarea__inner{border-color:#a8a8a8;border-radius:0;}
/deep/ .form_input .input_li:nth-child(7) .el-textarea__inner:focus{border-color:#0a64ba;}
/deep/ .form_input .el-input__inner{border-radius:0;border-color:#a8a8a8;color:#000;}
/deep/ .form_input .el-input.is-active .el-input__inner,
/deep/ .form_input .el-input__inner:focus{border-color:#0a64ba;}
.form_input_check{width:100%;min-height:20px;height:auto;font-size:12px;color:#999;line-height:20px;display:block;}
/deep/ .el-checkbox__input{margin-right:3px;vertical-align:top;margin-top:3px;}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{border-color:#0a64ba;background:#0a64ba;}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{border-color:#0a64ba;}
.consult_form button{width:140px;height:46px;display:block;margin:50px auto 0;background:#0a64ba;font-size:15px;
    color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;transform: 0.8s;}
.consult_form button:hover{background:#0c57c3;transform: 0.8s;}
.banner_wrap{width:100%;height:800px;display:block;float:left;overflow:hidden;}
.banner{width:1920px;height:800px;display:block;float:left;position:relative;left:50%;margin-left:-960px;}
.banner_text{width:700px;height:160px;display:block;position:absolute;left:50%;margin-left:-600px;top:50%;
    margin-top:-120px;font-size:42px;color:#fff;line-height:60px;text-align:left;font-weight:bold;}
.banner_text b{width:160px;height:4px;background:#fff;display:block;margin-bottom:40px;}
/deep/ .banner .el-carousel__indicators--horizontal{bottom:20px}
/deep/ .banner .el-carousel__indicator--horizontal{padding:12px 10px;}
/deep/ .banner .el-carousel__container{height:800px}
/deep/ .banner .el-carousel__button{width:10px;height:10px;border:1px solid #fff;border-radius:50%;background:transparent;}
/deep/ .banner .el-carousel__indicator--horizontal.is-active .el-carousel__button{background:#fff;width:20px;border-radius:5px;}
/deep/ .banner .el-carousel__arrow--right,
/deep/ .banner .el-notification.right{right:30px}
/deep/ .banner .el-carousel__arrow--left,
/deep/ .banner .el-notification.left{left:30px}
@media (min-width:992px) and (max-width:1200px){
    /deep/ .news_details .el-dialog{width:800px;height:600px;margin-top:70px;}
    /deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:15px 40px 30px;}
    .details_nr{width:100%;height:500px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
    .details_empty{margin-top:50px;}
    /deep/ .tijiao .el-dialog{width:360px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:40px;font-size:15px;line-height:40px;}
    /deep/ .consult .el-dialog{width:700px;}
    /deep/ .consult .el-dialog__title{font-size:20px;line-height:40px;}
    .consult_tips{height:24px;font-size:12px;line-height:24px;}
    /deep/ .consult .el-dialog--center .el-dialog__body{padding:0 30px 20px;}
    .consult_form{width:100%;height:410px;padding:0 50px;}
    .form_input{width:100%;height:260px;}
    .form_input .input_li{width:260px;height:auto;float:left;margin-left:20px;margin-top:15px;}
    .form_input .input_li:nth-child(3n-2){margin-left:20px;}
    .form_input .input_li:nth-child(2n-1){margin-left:0;}
    .form_input_check{min-height:20px;font-size:12px;line-height:20px;}
    /deep/ .el-checkbox__input{margin-right:3px;margin-top:3px;}
    .consult_form button{width:140px;height:40px;margin:30px auto 0;font-size:14px;line-height:40px;}
    .banner_wrap{height:500px;}
    .banner{width:1200px;height:500px;left:50%;margin-left:-600px;}
    .banner_text{width:500px;height:160px;margin-left:-400px;top:50%;
        margin-top:-100px;font-size:28px;line-height:40px;}
    .banner_text b{width:120px;height:3px;margin-bottom:30px;}
    /deep/ .banner .el-carousel__indicators--horizontal{bottom:20px}
    /deep/ .banner .el-carousel__indicator--horizontal{padding:12px 10px;}
    /deep/ .banner .el-carousel__container{height:500px}
    /deep/ .banner .el-carousel__button{width:10px;height:10px;border:1px solid #fff;border-radius:50%;background:transparent;}
    /deep/ .banner .el-carousel__indicator--horizontal.is-active .el-carousel__button{background:#fff;width:20px;border-radius:5px;}
    /deep/ .banner .el-carousel__arrow--right,
    /deep/ .banner .el-notification.right{right:50px;}
    /deep/ .banner .el-carousel__arrow--left,
    /deep/ .banner .el-notification.left{left:50px;}
}
@media (min-width:768px) and (max-width:991px){
    /deep/ .news_details .el-dialog{width:600px;height:500px;margin-top:50px;}
    /deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:15px 30px 30px;}
    .details_nr{width:100%;height:400px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
    .details_empty{margin-top:40px;}
    /deep/ .tijiao .el-dialog{width:360px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:40px;font-size:15px;line-height:40px;}
    /deep/ .consult .el-dialog{width:540px;}
    /deep/ .consult .el-dialog__title{font-size:20px;line-height:40px;}
    .consult_tips{height:40px;font-size:12px;line-height:20px;}
    /deep/ .consult .el-dialog--center .el-dialog__body{padding:0 30px 20px;}
    .consult_form{width:100%;height:410px;padding:0 20px;}
    .form_input{width:100%;height:260px;}
    .form_input .input_li{width:210px;height:auto;float:left;margin-left:20px;margin-top:15px;}
    .form_input .input_li:nth-child(3n-2){margin-left:20px;}
    .form_input .input_li:nth-child(2n-1){margin-left:0;}
    .form_input_check{min-height:20px;font-size:12px;line-height:20px;}
    /deep/ .el-checkbox__input{margin-right:3px;margin-top:3px;}
    .consult_form button{width:140px;height:40px;margin:20px auto 0;font-size:14px;line-height:40px;}
    .banner_wrap{height:415px;}
    .banner{width:1000px;height:415px;left:50%;margin-left:-500px;}
    .banner_text{width:600px;height:160px;margin-left:-350px;top:50%;
        margin-top:-100px;font-size:24px;line-height:36px;}
    .banner_text b{width:120px;height:3px;margin-bottom:30px;}
    /deep/ .banner .el-carousel__indicators--horizontal{bottom:10px}
    /deep/ .banner .el-carousel__indicator--horizontal{padding:12px 10px;}
    /deep/ .banner .el-carousel__container{height:415px}
    /deep/ .banner .el-carousel__button{width:10px;height:10px;border:1px solid #fff;border-radius:50%;background:transparent;}
    /deep/ .banner .el-carousel__indicator--horizontal.is-active .el-carousel__button{background:#fff;width:20px;border-radius:5px;}
    /deep/ .banner .el-carousel__arrow--right,
    /deep/ .banner .el-notification.right{right:50px;}
    /deep/ .banner .el-carousel__arrow--left,
    /deep/ .banner .el-notification.left{left:50px;}
}
@media (max-width:767px){
    .news_details{width:90%;left:5%;right:5%;}
    /deep/ .news_details .el-dialog{width:100%;height:500px;margin-top:50px;}
    /deep/ .news_details .el-dialog__body{border-top:1px solid #eee;padding:15px 15px 30px;}
    .details_nr{width:100%;height:400px;float:left;font-size:14px;color:#333;line-height:24px;overflow:hidden;overflow-y:scroll;}
    .details_empty{margin-top:0;}
    /deep/ .tijiao .el-dialog{width:300px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:40px;font-size:15px;line-height:40px;}
    /deep/ .consult .el-dialog{width:90%;left:5%;right:5%;margin:0;}
    /deep/ .consult .el-dialog__title{font-size:18px;line-height:40px;}
    .consult_tips{height:40px;font-size:12px;line-height:20px;}
    /deep/ .consult .el-dialog--center .el-dialog__body{padding:0 15px 20px;}
    .consult_form{width:100%;min-height:300px;height:auto;padding:0 20px;}
    .form_input{width:100%;height:auto;min-height:160px;float:left;}
    .form_input .input_li{width:100%;height:auto;float:left;margin-left:0;margin-top:10px;}
    .form_input .input_li:nth-child(3n-2){margin-left:0;}
    .form_input .input_li:nth-child(2n-1){margin-left:0;}
    .form_input_check{min-height:20px;font-size:12px;line-height:20px;float:left;margin-top:5px;padding-bottom:10px;}
    /deep/ .el-checkbox__input{margin-right:3px;margin-top:3px;}
    .consult_form button{width:120px;height:36px;margin:20px auto 0;font-size:13px;line-height:36px;}
    .banner_wrap{height:200px;}
    .banner{width:100%;height:200px;left:0;margin-left:0;}
    .banner img{height:200px;width:100%;}
    .banner_text{width:100%;height:80px;margin-left:0;top:50%;left:20px;z-index:999;
        margin-top:-50px;font-size:14px;line-height:20px;}
    .banner_text b{width:100px;height:2px;margin-bottom:20px;}
    /deep/ .banner .el-carousel__indicators--horizontal{bottom:0}
    /deep/ .banner .el-carousel__indicator--horizontal{padding:12px 10px;}
    /deep/ .banner .el-carousel__container{height:200px;}
    /deep/ .banner .el-carousel__button{width:6px;height:6px;border:1px solid #fff;border-radius:50%;background:transparent;}
    /deep/ .banner .el-carousel__indicator--horizontal.is-active .el-carousel__button{background:#fff;width:12px;border-radius:5px;}
    /deep/ .banner .el-carousel__arrow--right,
    /deep/ .banner .el-notification.right{right:50px;}
    /deep/ .banner .el-carousel__arrow--left,
    /deep/ .banner .el-notification.left{left:50px;}
}
@media (max-width:321px){
    /deep/ .tijiao .el-dialog{width:260px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:30px;font-size:14px;line-height:30px;}
    /deep/ .news_details .el-dialog{height:500px;margin-top:0;}
    /deep/ .consult .el-dialog{width:96%;left:2%;right:2%;margin:0;}
    /deep/ .consult .el-dialog__title{font-size:18px;line-height:40px;}
    .consult_tips{height:32px;font-size:12px;line-height:16px;}
    /deep/ .consult .el-dialog--center .el-dialog__body{padding:0 10px 20px;}
    .consult_form{width:100%;min-height:300px;height:auto;padding:0 10px;}
    .form_input{width:100%;height:auto;min-height:160px;float:left;}
    .form_input .input_li{width:100%;height:auto;float:left;margin-left:0;margin-top:6px;}
    .form_input .input_li:nth-child(3n-2){margin-left:0;}
    .form_input .input_li:nth-child(2n-1){margin-left:0;}
    .form_input_check{min-height:20px;font-size:12px;line-height:16px;float:left;margin-top:5px;}
    /deep/ .el-checkbox__input{margin-right:3px;margin-top:3px;}
    .consult_form button{width:120px;height:36px;margin:10px auto 0;font-size:13px;line-height:36px;}
}
.quote_wrap{width:100%;height:450px;display:block;float:left;background:url(../../static/images/quote_bg.jpg) center no-repeat;
    background-size:1920px 450px;}
.quote{width:700px;height:450px;display:block;margin:0 auto;padding:80px 0;}
.quote strong{width:100%;height:40px;font-size:26px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;}
.quote_title{width:100%;height:30px;display:block;float:left;margin-top:20px;font-size:16px;color:#0a64ba;letter-spacing:2px;
    line-height:30px;text-align:center;font-weight:bold;}
.quote_title i{width:20px;height:1px;background:#0a64ba;vertical-align:top;margin:15px 10px 14px;display:inline-block;}
.quote_nr{width:100%;height:48px;display:block;float:left;font-size:14px;color:#333;line-height:24px;margin-top:30px;text-align:center;}
.quote button{width:140px;height:46px;display:block;float:left;margin:76px 280px 0;background:#0a64ba;font-size:15px;
    color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;transform: 0.8s;}
.quote button:hover{background:#0c57c3;transform: 0.8s;}
@media (min-width:992px) and (max-width:1200px){
    .quote_wrap{width:100%;height:450px;background:url(../../static/images/quote_bg.jpg) center no-repeat;
        background-size:1920px 450px;}
    .quote{width:700px;height:450px;display:block;margin:0 auto;padding:80px 0;}
    .quote strong{width:100%;height:40px;font-size:26px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;}
    .quote_title{width:100%;height:30px;display:block;float:left;margin-top:20px;font-size:16px;color:#0a64ba;letter-spacing:2px;
        line-height:30px;text-align:center;font-weight:bold;}
    .quote_title i{width:20px;height:1px;background:#0a64ba;vertical-align:top;margin:15px 10px 14px;display:inline-block;}
    .quote_nr{width:100%;height:48px;display:block;float:left;font-size:14px;color:#333;line-height:24px;margin-top:30px;text-align:center;}
    .quote button{width:140px;height:46px;display:block;float:left;margin:76px 280px 0;background:#0a64ba;font-size:15px;
        color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;transform: 0.8s;}
}
@media (max-width:767px){
    .quote_wrap{width:100%;height:330px;background:url(../../static/images/quote_bg.jpg) center no-repeat;
        background-size:1920px 330px;}
    .quote{width:100%;height:330px;display:block;margin:0 auto;padding:40px 20px;}
    .quote strong{width:100%;height:30px;font-size:20px;color:#000;line-height:30px;display:block;float:left;text-align:center;letter-spacing:2px;}
    .quote_title{width:100%;height:30px;display:block;float:left;margin-top:20px;font-size:14px;color:#0a64ba;letter-spacing:2px;
        line-height:30px;text-align:center;font-weight:bold;}
    .quote_title i{width:20px;height:1px;background:#0a64ba;vertical-align:top;margin:15px 10px 14px;display:inline-block;}
    .quote_nr{width:100%;height:60px;display:block;float:left;font-size:12px;color:#333;line-height:20px;margin-top:20px;text-align:center;}
    .quote button{width:120px;height:36px;display:block;float:left;margin:30px auto 0;background:#0a64ba;font-size:14px;position:relative;left:50%;margin-left:-60px;
        color:#fff;line-height:36px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;transform: 0.8s;}
}

.service_wrap{width:100%;min-height:500px;height:auto;background:url(../../static/images/service_bg.jpg) top no-repeat;
    background-size:1920px 500px;float:left;}
.service_top{width:100%;height:380px;display:block;float:left;}
.service_introd{width:50%;height:380px;display:inline-block;float:left;padding:130px 150px 50px 50px;text-align:center;}
.service_introd b{width:100%;height:50px;font-size:42px;color:#fff;line-height:50px;display:block;float:left;}
.service_introd p{width:100%;height:120px;font-size:14px;display:block;float:left;color:#fff;line-height:24px;
    margin-top:30px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
.service_one_wrap{width:50%;height:380px;display:inline-block;float:left;padding-top:80px;}
.service_one{width:100%;height:300px;display:block;float:left;background-position:center;background-repeat:no-repeat;
    background-size:960px 300px;padding:80px 280px 80px 50px;position:relative;}
.service_one b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
.service_one strong{width:100%;height:30px;font-size:18px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
.service_one p{width:100%;height:48px;font-size:14px;display:block;float:left;color:#fff;line-height:24px;
    margin-top:22px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;opacity:0.8;}
.service_one span{width:140px;height:46px;display:block;background:#0a64ba;font-size:13px;position:absolute;right:50px;top:50%;margin-top:-23px;z-index:10;
    color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;opacity:0.8;transform: 0.8s;}
.service_one span:hover{background:#0c57c3;opacity:1.0;transform: 0.8s;}
.service_ul{width:100%;height:auto;float:left;}
.service_ul .service_li{width:25%;height:440px;display:inline-block;float:left;background-position:center;background-repeat:no-repeat;
    background-size:480px 448px;padding:80px 50px;}
.service_li b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
.service_li strong{width:100%;height:30px;font-size:18px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
.service_li p{width:100%;height:96px;font-size:14px;display:block;float:left;color:#fff;line-height:24px;
    margin-top:22px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:4;-webkit-box-orient: vertical;opacity:0.8;}
.service_li span{width:140px;height:46px;display:block;background:#0a64ba;font-size:13px;float:left;margin-top:46px;
    color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;opacity:0.8;transform: 0.8s;}
.service_li span:hover{background:#0c57c3;opacity:1.0;transform: 0.8s;}
@media (min-width:992px) and (max-width:1200px){
    .service_wrap{width:100%;min-height:400px;height:auto;background:url(../../static/images/service_bg.jpg) top no-repeat;
        background-size:1920px 400px;float:left;}
    .service_top{width:100%;height:280px;display:block;float:left;}
    .service_introd{width:50%;height:280px;padding:120px 150px 50px 50px;}
    .service_introd b{height:50px;font-size:32px;line-height:50px;}
    .service_introd p{width:100%;height:120px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:30px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
    .service_one_wrap{width:50%;height:240px;display:inline-block;float:left;padding-top:40px;}
    .service_one{width:100%;height:240px;display:block;float:left;background-position:center;background-repeat:no-repeat;
        background-size:960px 240px;padding:40px 200px 40px 30px;position:relative;}
    .service_one b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
    .service_one strong{width:100%;height:30px;font-size:16px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
    .service_one p{width:100%;height:40px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:20px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;opacity:0.8;}
    .service_one span{width:120px;height:36px;font-size:12px;right:50px;margin-top:-18px;line-height:36px;}
    .service_ul .service_li{width:25%;height:340px;background-size:480px 448px;padding:40px 30px;}
    .service_li b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
    .service_li strong{width:100%;height:30px;font-size:16px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
    .service_li p{width:100%;height:96px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:20px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
    .service_li span{width:120px;height:36px;font-size:12px;margin-top:35px;line-height:36px;}
}
@media (min-width:768px) and (max-width:991px){
    .service_wrap{width:100%;min-height:400px;height:auto;background:url(../../static/images/service_bg.jpg) top no-repeat;
        background-size:1920px 400px;float:left;}
    .service_top{width:100%;height:280px;display:block;float:left;}
    .service_introd{width:50%;height:280px;padding:120px 150px 50px 50px;}
    .service_introd b{height:50px;font-size:32px;line-height:50px;}
    .service_introd p{width:100%;height:120px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:30px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
    .service_one_wrap{width:50%;height:240px;display:inline-block;float:left;padding-top:40px;}
    .service_one{width:100%;height:240px;display:block;float:left;background-position:center;background-repeat:no-repeat;
        background-size:960px 240px;padding:40px 200px 40px 30px;position:relative;}
    .service_one b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
    .service_one strong{width:100%;height:30px;font-size:16px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
    .service_one p{width:100%;height:40px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:20px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;opacity:0.8;}
    .service_one span{width:120px;height:36px;font-size:12px;right:50px;margin-top:-18px;line-height:36px;}
    .service_ul .service_li{width:25%;height:340px;background-size:480px 448px;padding:40px 30px;}
    .service_li b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
    .service_li strong{width:100%;height:30px;font-size:16px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
    .service_li p{width:100%;height:96px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:20px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
    .service_li span{width:120px;height:36px;font-size:12px;margin-top:35px;line-height:36px;}
}
@media (max-width:767px){
    .service_wrap{width:100%;min-height:150px;height:auto;background:url(../../static/images/service_bg.jpg) top no-repeat;
        background-size:1920px 150px;float:left;}
    .service_top{width:100%;min-height:150px;height:auto;display:block;float:left;}
    .service_introd{width:100%;height:150px;padding:50px 20px;}
    .service_introd b{height:50px;font-size:28px;line-height:50px;}
    .service_introd p{width:100%;height:120px;font-size:12px;display:block;float:left;color:#fff;line-height:20px;
        margin-top:30px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
    .service_one_wrap{width:100%;height:280px;display:inline-block;float:left;padding-top:0;}
    .service_one{width:100%;height:280px;display:block;float:left;background-position:center;background-repeat:no-repeat;
        background-size:960px 280px;padding:40px 20px;position:relative;}
    .service_one b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
    .service_one strong{width:100%;height:30px;font-size:16px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
    .service_one p{width:100%;height:32px;font-size:12px;display:block;float:left;color:#fff;line-height:16px;
        margin-top:20px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;opacity:0.8;}
    .service_one span{width:120px;height:36px;font-size:12px;left:30px;margin-top:0;line-height:36px;bottom:30px;top:210px;}
    .service_ul .service_li{width:100%;height:280px;background-size:480px 280px;padding:40px 20px;}
    .service_li b{width:100%;height:30px;font-size:26px;color:#fff;line-height:30px;display:block;float:left;}
    .service_li strong{width:100%;height:30px;font-size:16px;color:#fff;line-height:30px;display:block;float:left;margin-top:10px;}
    .service_li p{width:100%;height:80px;font-size:12px;display:block;float:left;color:#fff;line-height:16px;
        margin-top:20px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;opacity:0.8;}
    .service_li span{width:120px;height:36px;font-size:12px;margin-top:0;line-height:36px;}
}
.project_wrap{width:100%;height:800px;background:url(../../static/images/project_bg.jpg) center no-repeat;background-size:1920px 800px;
    display:block;float:left;padding:80px 0;}
.project{width:1200px;height:640px;display:block;margin:0 auto;}
.project_title{width:100%;height:40px;font-size:26px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
.project_nr{width:100%;height:540px;display:block;float:left;margin-top:60px;position:relative;}
.project_mid_img{width:520px;height:540px;display:block;background:url(../../static/images/project_qiu.png) center no-repeat;
    background-size:520px 540px;position:absolute;top:0;left:50%;margin-left:-260px;z-index:10;}
.project_mid_img b{width:50%;height:540px;padding:0 30px 80px;font-size:20px;color:#fff;display:flex;float:left;justify-content:center;align-items:center;cursor:pointer;}
.project_mid_img strong{width:50%;height:540px;padding:80px 30px 0;font-size:20px;color:#fff;display:flex;float:left;justify-content:center;align-items:center;cursor:pointer;}
.project_ul_left{width:50%;height:540px;display:inline-block;float:left;padding-right:50px;}
.project_ul_left .project_li{width:100%;height:100px;display:block;float:left;margin-top:20px;cursor:pointer;}
.project_li .project_li_title{width:100%;height:40px;display:flex;float:left;}
.project_ul_left .project_li .project_li_title b{width:auto;height:40px;font-size:20px;color:#0a64ba;line-height:40px;
    padding-right:25px;display:inline-block;}
.project_li .project_li_title i{width:auto;height:1px;background:#0a64ba;display:inline-block;flex:1;margin-top:20px;}
.project_ul_left .project_li p{width:100%;height:72px;font-size:14px;color:#333;line-height:24px;display:block;float:left;
    padding-right:230px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
.project_ul_right{width:50%;height:540px;display:inline-block;float:left;margin-top:80px;padding-left:50px;}
.project_ul_right .project_li{width:100%;height:100px;display:block;float:left;margin-top:20px;cursor:pointer;}
.project_ul_right .project_li .project_li_title b{width:auto;height:40px;font-size:20px;color:#0a64ba;line-height:40px;
    padding-left:25px;display:inline-block;}
.project_li .project_li_title i{width:auto;height:1px;background:#0a64ba;display:inline-block;flex:1;margin-top:20px;}
.project_ul_right .project_li p{width:100%;height:72px;font-size:14px;color:#333;line-height:24px;display:block;float:left;
    text-align:right;padding-left:230px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
@media (min-width:992px) and (max-width:1200px){
    .project_wrap{width:100%;height:800px;background:url(../../static/images/project_bg.jpg) center no-repeat;background-size:1920px 800px;
        display:block;float:left;padding:60px 0;}
    .project{width:1000px;height:640px;display:block;margin:0 auto;}
    .project_title{width:100%;height:40px;font-size:24px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
    .project_nr{width:100%;height:540px;display:block;float:left;margin-top:60px;position:relative;}
    .project_mid_img{width:520px;height:540px;display:block;background:url(../../static/images/project_qiu.png) center no-repeat;
        background-size:520px 540px;position:absolute;top:0;left:50%;margin-left:-260px;z-index:10;}
    .project_mid_img b{width:50%;height:540px;padding:0 30px 80px;font-size:20px;color:#fff;display:flex;float:left;justify-content:center;align-items:center;cursor:pointer;}
    .project_mid_img strong{width:50%;height:540px;padding:80px 30px 0;font-size:20px;color:#fff;display:flex;float:left;justify-content:center;align-items:center;cursor:pointer;}
    .project_ul_left{width:50%;height:540px;display:inline-block;float:left;padding-right:50px;}
    .project_ul_left .project_li{width:100%;height:100px;display:block;float:left;margin-top:20px;cursor:pointer;}
    .project_li .project_li_title{width:100%;height:40px;display:flex;float:left;}
    .project_ul_left .project_li .project_li_title b{width:auto;height:40px;font-size:20px;color:#0a64ba;line-height:40px;
        padding-right:25px;display:inline-block;}
    .project_li .project_li_title i{width:auto;height:1px;background:#0a64ba;display:inline-block;flex:1;margin-top:20px;}
    .project_ul_left .project_li p{width:100%;height:60px;font-size:12px;color:#333;line-height:20px;display:block;float:left;
        padding-right:230px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
    .project_ul_right{width:50%;height:540px;display:inline-block;float:left;margin-top:80px;padding-left:50px;}
    .project_ul_right .project_li{width:100%;height:100px;display:block;float:left;margin-top:20px;cursor:pointer;}
    .project_ul_right .project_li .project_li_title b{width:auto;height:40px;font-size:20px;color:#0a64ba;line-height:40px;
        padding-left:25px;display:inline-block;}
    .project_li .project_li_title i{width:auto;height:1px;background:#0a64ba;display:inline-block;flex:1;margin-top:20px;}
    .project_ul_right .project_li p{width:100%;height:60px;font-size:12px;color:#333;line-height:20px;display:block;float:left;
        text-align:right;padding-left:230px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
}
@media (min-width:768px) and (max-width:991px){
    .project_wrap{width:100%;height:600px;background:url(../../static/images/project_bg.jpg) center no-repeat;background-size:1920px 800px;
        display:block;float:left;padding:50px 0;}
    .project{width:750px;height:640px;display:block;margin:0 auto;}
    .project_title{width:100%;height:40px;font-size:24px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
    .project_nr{width:100%;height:340px;display:block;float:left;margin-top:60px;position:relative;}
    .project_mid_img{width:327px;height:340px;display:block;background:url(../../static/images/project_qiu.png) center no-repeat;
        background-size:327px 340px;position:absolute;top:0;left:50%;margin-left:-163px;z-index:10;}
    .project_mid_img b{width:50%;height:340px;padding:0 30px 60px;font-size:16px;color:#fff;display:flex;float:left;justify-content:center;align-items:center;cursor:pointer;}
    .project_mid_img strong{width:50%;height:340px;padding:60px 30px 0;font-size:15px;color:#fff;display:flex;float:left;justify-content:center;align-items:center;cursor:pointer;}
    .project_ul_left{width:50%;height:340px;display:inline-block;float:left;padding-right:50px;}
    .project_ul_left .project_li{width:100%;height:60px;display:block;float:left;margin-top:15px;cursor:pointer;}
    .project_li .project_li_title{width:100%;height:20px;display:flex;float:left;}
    .project_ul_left .project_li .project_li_title b{width:auto;height:20px;font-size:15px;color:#0a64ba;line-height:20px;
        padding-right:15px;display:inline-block;}
    .project_li .project_li_title i{width:auto;height:1px;background:#0a64ba;display:inline-block;flex:1;margin-top:10px;}
    .project_ul_left .project_li p{width:100%;height:32px;font-size:12px;color:#333;line-height:16px;display:block;float:left;
        padding-right:130px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;}
    .project_ul_right{width:50%;height:340px;display:inline-block;float:left;margin-top:60px;padding-left:50px;}
    .project_ul_right .project_li{width:100%;height:60px;display:block;float:left;margin-top:15px;cursor:pointer;}
    .project_ul_right .project_li .project_li_title b{width:auto;height:20px;font-size:15px;color:#0a64ba;line-height:20px;
        padding-left:15px;display:inline-block;}
    .project_li .project_li_title i{width:auto;height:1px;background:#0a64ba;display:inline-block;flex:1;margin-top:10px;}
    .project_ul_right .project_li p{width:100%;height:32px;font-size:12px;color:#333;line-height:16px;display:block;float:left;
        text-align:right;padding-left:130px;overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
}
@media (max-width:767px){
    .project_wrap{display:none;}
}
.about_wrap{width:100%;height:800px;background:url(../../static/images/about_bg.png) top no-repeat;
    background-size:1920px 750px;display:block;float:left;padding-top:80px;}
.about_nr{width:1200px;height:420px;display:block;float:left;position:relative;left:50%;margin-left:-600px;margin-top:0;}
.about_title{width:100%;height:40px;font-size:26px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
.about_text{width:100%;height:273px;display:block;float:left;padding-left:430px;position:relative;margin-top:60px;}
.about_text .about_img{width:400px;height:273px;display:block;position:absolute;left:0;top:0;z-index:10;}
.about_text .about_img img{height:100%;width:auto;display:block;}
.about_p{width:100%;height:144px;display:block;font-size:14px;color:#333;line-height:24px;float:left;opacity:0.9;
    overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:6;-webkit-box-orient: vertical;}
.about_text button{width:140px;height:46px;display:block;float:left;background:#0a64ba;font-size:13px;margin-top:20px;
    color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;opacity:0.8;transform: 0.8s;}
.about_text button:hover{background:#0c57c3;opacity:1.0;transform: 0.8s;}
.about_bottom{width:100%;height:300px;display:block;float:left;background:url(../../static/images/about_bottom.png) center no-repeat;
    background-size:1920px 300px;}
.about_news{width:1200px;height:300px;display:block;margin:0 auto;padding:30px 0 40px;}
.about_news .about_news_ul{width:350px;height:230px;display:inline-block;float:left;margin-left:75px;overflow:hidden;}
.about_news .about_news_ul:first-child{margin-left:0;}
.about_news_title{width:100%;height:45px;display:block;float:left;border-bottom:1px solid;position:relative;border-color: rgba(0,0,0,0.4);}
.about_news_title b{width:auto;height:45px;border-bottom:1px solid #333;font-size:20px;color:#333;line-height:44px;
    display:block;position:absolute;left:0;top:0;z-index:10;}
.about_news_ulst{width:100%;height:172px;display:block;float:left;margin-top:13px;}
.about_news_li{width:100%;height:43px;display:block;float:left;position:relative;padding-left:65px;border-bottom:1px dashed;
    border-color: rgba(0,0,0,0.4);opacity:0.8;cursor:pointer;transform: 0.8s;}
.about_news_li b{width:65px;height:42px;font-size:15px;font-weight:normal;color:#333;line-height:42px;display:block;position:absolute;left:0;top:0;z-index:2;}
.about_news_li span{width:100%;height:42px;display:block;font-size:14px;color:#333;line-height:42px;
    overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.about_news_li:hover{opacity:1.0;border-color: rgba(0,0,0,1.0);transform: 0.8s;}
.about_news .about_news_ul:nth-child(3) .about_news_li{padding-left:0;}
@media (min-width:992px) and (max-width:1200px){
    .about_wrap{width:100%;height:720px;background:url(../../static/images/about_bg.png) top no-repeat;
        background-size:1920px 660px;display:block;float:left;padding-top:60px;}
    .about_nr{width:1000px;height:400px;left:50%;margin-left:-500px;}
    .about_title{height:36px;font-size:24px;line-height:36px;}
    .about_text{width:100%;height:273px;display:block;float:left;padding-left:430px;position:relative;margin-top:40px;}
    .about_text .about_img{width:400px;height:273px;display:block;position:absolute;left:0;top:0;z-index:10;}
    .about_text .about_img img{height:100%;width:auto;display:block;}
    .about_p{width:100%;height:192px;display:block;font-size:14px;color:#333;line-height:24px;float:left;opacity:0.9;
        overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:8;-webkit-box-orient: vertical;}
    .about_text button{width:120px;height:36px;font-size:12px;margin-top:20px;line-height:36px;}
    .about_bottom{width:100%;height:260px;display:block;float:left;background:url(../../static/images/about_bottom.png) center no-repeat;
        background-size:1920px 260px;}
    .about_news{width:1000px;height:260px;display:block;margin:0 auto;padding:20px 0;}
    .about_news .about_news_ul{width:300px;height:230px;display:inline-block;float:left;margin-left:50px;overflow:hidden;}
    .about_news .about_news_ul:first-child{margin-left:0;}
    .about_news_title{width:100%;height:45px;}
    .about_news_title b{width:auto;height:45px;font-size:16px;line-height:44px;}
    .about_news_ulst{width:100%;height:164px;display:block;float:left;margin-top:13px;}
    .about_news_li{width:100%;height:41px;padding-left:65px;}
    .about_news_li b{width:65px;height:40px;font-size:14px;line-height:40px;}
    .about_news_li span{height:40px;font-size:13px;line-height:40px;}
}
@media (min-width:768px) and (max-width:991px){
    .about_wrap{width:100%;height:700px;background:url(../../static/images/about_bg.png) top no-repeat;
        background-size:1920px 660px;display:block;float:left;padding-top:50px;}
    .about_nr{width:750px;height:400px;left:50%;margin-left:-375px;}
    .about_title{height:36px;font-size:24px;line-height:36px;}
    .about_text{width:100%;height:273px;display:block;float:left;padding-left:430px;position:relative;margin-top:40px;}
    .about_text .about_img{width:400px;height:273px;display:block;position:absolute;left:0;top:0;z-index:10;}
    .about_p{width:100%;height:160px;display:block;font-size:12px;color:#333;line-height:20px;float:left;opacity:0.9;
        overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:8;-webkit-box-orient: vertical;}
    .about_text button{width:120px;height:36px;font-size:12px;margin-top:20px;line-height:36px;}
    .about_bottom{width:100%;height:260px;display:block;float:left;background:url(../../static/images/about_bottom.png) center no-repeat;
        background-size:1920px 260px;}
    .about_news{width:750px;height:240px;display:block;margin:0 auto;padding:20px 0;}
    .about_news .about_news_ul{width:230px;height:200px;display:inline-block;float:left;margin-left:30px;overflow:hidden;}
    .about_news .about_news_ul:first-child{margin-left:0;}
    .about_news_title{width:100%;height:45px;}
    .about_news_title b{width:auto;height:45px;font-size:16px;line-height:44px;}
    .about_news_ulst{width:100%;height:164px;display:block;float:left;margin-top:13px;}
    .about_news_li{width:100%;height:41px;padding-left:65px;}
    .about_news_li b{width:65px;height:40px;font-size:14px;line-height:40px;}
    .about_news_li span{height:40px;font-size:13px;line-height:40px;}
}
@media(max-width:767px){
    .about_wrap{width:100%;min-height:700px;height:auto;background:url(../../static/images/about_bg.png) top no-repeat;
        background-size:1920px 600px;display:block;float:left;padding:40px 15px 0;}
    .about_nr{width:100%;min-height:400px;margin-left:0;left:0;height:auto;}
    .about_title{height:36px;font-size:20px;line-height:36px;}
    .about_text{width:100%;height:auto;display:block;float:left;padding-left:0;position:relative;margin-top:20px;padding-bottom:20px;}
    .about_text .about_img{width:100%;height:auto;position:static;display:block;z-index:1;}
    .about_text .about_img img{width:100%;height:auto;display:block;}
    .about_p{width:100%;height:auto;display:block;font-size:12px;color:#333;line-height:20px;float:left;opacity:0.9;
        overflow:hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;margin-top:15px;
        display: -webkit-box;-webkit-line-clamp:18;-webkit-box-orient: vertical;}
    .about_text button{width:120px;height:36px;font-size:12px;margin-top:20px;line-height:36px;}
    .about_bottom{width:100%;min-height:260px;height:auto;display:block;float:left;background:url(../../static/images/about_bottom.png) center no-repeat;
        background-size:1920px 260px;}
    .about_news{width:100%;min-height:240px;height:auto;display:block;margin:0 auto;padding:20px 0;float:left;}
    .about_news .about_news_ul{width:100%;height:auto;display:inline-block;float:left;margin-left:0;overflow:hidden;margin-top:20px;}
    .about_news .about_news_ul:first-child{margin-left:0;margin-top:0;}
    .about_news_title{width:100%;height:41px;}
    .about_news_title b{width:auto;height:41px;font-size:15px;line-height:40px;}
    .about_news_ulst{width:100%;min-height:44px;height:auto;display:block;float:left;margin-top:10px;}
    .about_news_li{width:100%;height:35px;padding-left:65px;}
    .about_news_li b{width:65px;height:34px;font-size:14px;line-height:34px;}
    .about_news_li span{height:35px;font-size:12px;line-height:34px;}
}
.parents_wrap{width:100%;min-height:200px;height:auto;float:left;padding:80px 0 60px;}
.parents{width:1200px;min-height:60px;height:auto;float:left;position:relative;left:50%;margin-left:-600px;}
.parents_title{width:100%;height:40px;font-size:26px;color:#000;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
.parents_ul{width:100%;height:auto;min-height:60px;float:left;margin-top:60px;}
.parents_ul .parents_li{width:297px;height:142px;display:inline-block;padding:15px 17px 15px 18px;cursor:pointer;
    border:1px solid #ddd;float:left;margin-left:4px;margin-top:4px;transform: 0.8s;overflow:hidden;}
.parents_ul .parents_li img{height:100%;width:auto;display:block;margin:0 auto;}
.parents_ul .parents_li:nth-child(4n-3){margin-left:0;}
.parents_ul .parents_li:nth-child(1){margin-top:0;}
.parents_ul .parents_li:nth-child(2){margin-top:0;}
.parents_ul .parents_li:nth-child(3){margin-top:0;}
.parents_ul .parents_li:nth-child(4){margin-top:0;}
.parents_ul .parents_li:hover{border-color:#0a64ba;transform: 0.8s;}
.family_wrap{width:100%;min-height:810px;height:auto;display:block;float:left;padding:0;background:url(../../static/images/family_bg.jpg) top no-repeat;
    background-size:1920px 810px;overflow:hidden;}
.family{width:100%;height:810px;display:block;position:relative;float:left;overflow:hidden;}
.family_li{width:25%;height:270px;display:inline-block;float:left;overflow:hidden;}
.family_li img{width:100%;height:auto;display:block;}
.family_title{width:50%;height:270px;background:url(../../static/images/family_title_bg.jpg) center no-repeat;background-size:960px 270px;
    position:absolute;left:25%;top:0;z-index:10;padding:95px 30px;cursor:pointer;}
.family_title b{width:100%;height:40px;font-size:26px;color:#fff;line-height:40px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
.family_title span{width:100%;height:40px;font-size:14px;color:#fff;line-height:40px;text-align:center;display:block;}
.family_nr{width:100%;height:570px;display:block;float:left;margin-top:50px;position:relative;cursor:pointer;}
.family_nr img{width:100%;height:auto;display:block;}
.family_nr span{width:240px;height:140px;position:absolute;left:50%;margin-left:-120px;display:flex;overflow:hidden;
    top:20px;font-size:15px;color:#fff;line-height:30px;justify-content:center;align-items:center;text-align:center;}
.shixiao{width:1200px;height:800px;display:block;float:left;position:relative;left:50%;margin-left:-600px;}
.shixiao img{width:100%;height:auto;display:block;}
@media (min-width:992px) and (max-width:1200px){
    .parents_wrap{padding:60px 0 40px;}
    .parents{width:1000px;min-height:60px;margin-left:-500px;}
    .parents_title{height:36px;font-size:24px;line-height:36px;}
    .parents_ul{width:100%;height:auto;min-height:60px;float:left;margin-top:40px;}
    .parents_ul .parents_li{width:247px;height:132px;display:inline-block;padding:15px 17px 15px 18px;cursor:pointer;
        border:1px solid #ddd;float:left;margin-left:4px;margin-top:4px;transform: 0.8s;overflow:hidden;}
    .parents_ul .parents_li:nth-child(4n-3){margin-left:0;}
    .parents_ul .parents_li:nth-child(1){margin-top:0;}
    .parents_ul .parents_li:nth-child(2){margin-top:0;}
    .parents_ul .parents_li:nth-child(3){margin-top:0;}
    .parents_ul .parents_li:nth-child(4){margin-top:0;}
    .family_wrap{width:100%;min-height:450px;background:url(../../static/images/family_bg.jpg) top no-repeat;
        background-size:1920px 450px;}
    .family{height:450px;}
    .family_li{width:25%;height:150px;}
    .family_title{width:50%;height:150px;background:url(../../static/images/family_title_bg.jpg) center no-repeat;background-size:960px 150px;
        position:absolute;left:25%;top:0;z-index:10;padding:42px 30px;cursor:pointer;}
    .family_title b{width:100%;height:36px;font-size:24px;color:#fff;line-height:36px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
    .family_title span{width:100%;height:30px;font-size:12px;color:#fff;line-height:30px;text-align:center;display:block;float:left;}
    .family_nr{width:100%;height:570px;display:block;float:left;margin-top:50px;position:relative;cursor:pointer;}
    .family_nr span{width:240px;height:140px;position:absolute;left:50%;margin-left:-120px;display:flex;overflow:hidden;
        top:20px;font-size:15px;color:#fff;line-height:30px;justify-content:center;align-items:center;text-align:center;}
    .shixiao{width:1000px;height:667px;margin-left:-500px;}
}
@media (min-width:768px) and (max-width:991px){
    .parents_wrap{padding:50px 0 40px;}
    .parents{width:750px;min-height:60px;margin-left:-375px;}
    .parents_title{height:36px;font-size:24px;line-height:36px;}
    .parents_ul{width:100%;height:auto;min-height:60px;float:left;margin-top:40px;}
    .parents_ul .parents_li{width:185px;height:102px;display:inline-block;padding:10px 17px 10px 18px;cursor:pointer;
        border:1px solid #ddd;float:left;margin-left:3px;margin-top:3px;transform: 0.8s;overflow:hidden;}
    .parents_ul .parents_li:nth-child(4n-3){margin-left:0;}
    .parents_ul .parents_li:nth-child(1){margin-top:0;}
    .parents_ul .parents_li:nth-child(2){margin-top:0;}
    .parents_ul .parents_li:nth-child(3){margin-top:0;}
    .parents_ul .parents_li:nth-child(4){margin-top:0;}
    .family_wrap{width:100%;min-height:360px;background:url(../../static/images/family_bg.jpg) top no-repeat;
        background-size:1920px 360px;}
    .family{height:360px;}
    .family_li{width:25%;height:120px;}
    .family_title{width:50%;height:120px;background:url(../../static/images/family_title_bg.jpg) center no-repeat;background-size:960px 120px;
        position:absolute;left:25%;top:0;z-index:10;padding:21px 10px;cursor:pointer;}
    .family_title b{width:100%;height:36px;font-size:20px;color:#fff;line-height:36px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
    .family_title span{width:100%;height:30px;font-size:12px;color:#fff;line-height:30px;text-align:center;display:block;float:left;}
    .family_nr{width:100%;height:570px;display:block;float:left;margin-top:50px;position:relative;cursor:pointer;}
    .family_nr span{width:240px;height:140px;position:absolute;left:50%;margin-left:-120px;display:flex;overflow:hidden;
        top:20px;font-size:15px;color:#fff;line-height:30px;justify-content:center;align-items:center;text-align:center;}
    .shixiao{width:750px;height:500px;margin-left:-370px;}
}
@media (max-width:767px){
    .parents_wrap{padding:40px 0 30px;}
    .parents{width:100%;min-height:60px;margin-left:0;left:0;}
    .parents_title{height:36px;font-size:20px;line-height:36px;}
    .parents_ul{width:100%;height:auto;min-height:60px;float:left;margin-top:40px;padding:0 15px;}
    .parents_ul .parents_li{width:49%;height:102px;display:inline-block;padding:10px 17px 10px 18px;cursor:pointer;
        border:1px solid #ddd;float:left;margin-left:2%;margin-top:5px;transform: 0.8s;overflow:hidden;}
    .parents_ul .parents_li:nth-child(4n-3){margin-left:0;}
    .parents_ul .parents_li:nth-child(2n-1){margin-left:0;}
    .parents_ul .parents_li:nth-child(1){margin-top:0;}
    .parents_ul .parents_li:nth-child(2){margin-top:0;}
    .parents_ul .parents_li:nth-child(3){margin-top:5px;}
    .parents_ul .parents_li:nth-child(4){margin-top:5px;}
    .family_wrap{width:100%;min-height:300px;background:url(../../static/images/family_bg.jpg) top no-repeat;
        background-size:1920px 300px;display:none;}
    .family{height:auto;}
    .family_li{width:100%;height:auto;}
    .family_li img{width:100%;height:100%;display:block;}
    .family_title{width:80%;height:120px;background:url(../../static/images/family_title_bg.jpg) center no-repeat;background-size:960px 120px;
        position:absolute;left:10%;top:0;z-index:10;padding:21px 10px;cursor:pointer;}
    .family_title b{width:100%;height:36px;font-size:18px;color:#fff;line-height:36px;display:block;float:left;text-align:center;letter-spacing:2px;font-weight:bold;}
    .family_title span{width:100%;min-height:20px;height:auto;font-size:12px;color:#fff;line-height:20px;text-align:center;display:block;float:left;}
    .family_nr{width:100%;height:570px;display:block;float:left;margin-top:50px;position:relative;cursor:pointer;}
    .family_nr span{width:240px;height:140px;position:absolute;left:50%;margin-left:-120px;display:flex;overflow:hidden;
        top:20px;font-size:15px;color:#fff;line-height:30px;justify-content:center;align-items:center;text-align:center;}
    .shixiao{width:100%;height:auto;margin-left:0;left:0;}
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue